import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { di } from 'react-magnetic-di';
import Checkbox from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
const BooleanInputPrompt = ({
  userInputPrompt
}) => {
  const {
    variableName,
    displayName,
    defaultValue
  } = userInputPrompt;
  return /*#__PURE__*/React.createElement(CheckboxField, {
    name: variableName,
    defaultIsChecked: defaultValue || false
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
    label: displayName
  })));
};
export default BooleanInputPrompt;